import React, {useImperativeHandle, useRef} from 'react'
import WizModal from '../../../components/modal/WizModal'
import {IUserActiveLeague} from '../../../apis/user/getUserDetail'
import UserActiveLeagueItem from './UserActiveLeagueItem'
import useQueryGetUserProfile from '../../../hooks/api/user/useQueryGetUserProfile'

interface IProps {
    className?: string
    data?: IUserActiveLeague[]
    userId?: string
}

const UserActiveLeagueModal = ({className, data, userId}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))
    const {data: profile} = useQueryGetUserProfile(userId)
    return (
        <>
            <WizModal title={'User Leagues'} className={`${className} max-h-[80vh]`} ref={modalRef}>
                <div className={'space-y-[50px] py-[30px]'}>
                    {data?.map(league => (
                        <article
                            key={league?.league_id}
                            className={'space-y-[20px] border-b border-b-line02 pb-[30px] last:border-none'}>
                            <UserActiveLeagueItem league={league} profile={profile} />
                        </article>
                    ))}
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(UserActiveLeagueModal)
